import { httpClient } from '@/services/http/httpClient'

export type SendAuthCodeParams = {
  email: string
}

export async function sendAuthCode({ email }: SendAuthCodeParams) {
  await httpClient.post('/users/sessions', {
    email,
  })
}
